import React from 'react';
import { Box, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ja } from 'date-fns/locale';
import { MonthlyDoctorsShiftContainer } from './containers';

/**
 * 月次医師シフト管理ページ
 *
 * @description
 * 月次医師シフト管理画面のエントリーポイント。
 * LocalizationProviderでラップしてコンテナをレンダリングする。
 *
 * @returns {React.ReactElement} ページコンポーネント
 *
 * @example
 * // App.tsx でのルーティング設定
 * <Route path="/doctors/shifts" element={<MonthlyDoctorsShiftPage />} />
 */
const MonthlyDoctorsShiftPage: React.FC = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        {/* ページタイトル */}
        <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
          <Typography variant="h5" component="h1">
            月次医師シフト管理
          </Typography>
        </Box>

        {/* メインコンテンツ */}
        <Box sx={{ flex: 1, overflow: 'hidden' }}>
          <MonthlyDoctorsShiftContainer />
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export { MonthlyDoctorsShiftPage };
